
const inboxFilters = {
	namespaced: true,
	state: {
		filters: {
			after: '',
			before: '',
			reverse: false,
			pageIds : [],
			tags : [],
			notTags : [],
			assignedTo: []
		},
		inboxFilterLastUpdatedTime: ''
	},
	getters: {
		getInboxFilters(state){
			return state.filters
		},
		getInboxFilterLastUpdatedTime(state){
			return state.inboxFilterLastUpdatedTime
		}
	},
	mutations: {
		setInboxFilters(state, filters){
			state.filters = filters
		},
		setInboxFiltersReverse(state, reverse){
			state.filters.reverse = reverse
		},
		setInboxFiltersStatusId(state, statusId){
			state.filters.statusId = statusId
		},
		setInboxFiltersPageId(state, pageId){
			state.filters.pageId = pageId
		},
		setInboxFiltersPageIds(state, pageIds){
			state.filters.pageIds = pageIds
		},
		setInboxFiltersType(state, _type){
			state.filters._type = _type
		},
		setInboxFiltersSkip(state, skip){
			state.filters.skip = skip
		},
		setInboxFiltersTags(state, tags){
			state.filters.tags = tags
		},
		setInboxFiltersNotTags(state, notTags){
			state.filters.notTags = notTags
		},
		setInboxFiltersAfter(state, after){
			state.filters.after = after
		},
		setInboxFiltersBefore(state, before){
			state.filters.before = before
		},
		setInboxFiltersIsMention(state, isMention){
			state.filters.isMention = isMention
		},
		setInboxFiltersAssignedToMe(state, assignedTo){
			state.filters.assignedTo = assignedTo
		},
		setInboxFilterLastUpdatedTime(state, updatedTime){
			state.inboxFilterLastUpdatedTime = updatedTime
		},
		setSaveFilters(state, inboxFilters, email){
			localStorage.setItem(email+'inboxFilter', JSON.stringify(inboxFilters));
			state.filters = inboxFilters;
		}
	},
	actions: {
		setInboxFilters({ commit }, filters){
			commit('setInboxFilters', filters)
	},
		setInboxFiltersReverse({ commit }, reverse){
			commit('setInboxFiltersReverse', reverse);
	},
		setInboxFiltersStatusId({ commit }, statusId){
			commit('setInboxFiltersStatusId', statusId)
	},
		setInboxFiltersPageIds({ commit }, pageIds){
			commit('setInboxFiltersPageIds', pageIds)
	},
		setInboxFiltersPageId({ commit }, pageId){
			commit('setInboxFiltersPageId', pageId)
	},
		setInboxFiltersType({ commit }, _type){
			commit('setInboxFiltersType', _type)
	},
		setInboxFiltersSkip({ commit }, skip){
			commit('setInboxFiltersSkip', skip)
	},
		setInboxFiltersTags({ commit }, tags){
			commit('setInboxFiltersTags', tags)
	},
		setInboxFiltersNotTags({ commit }, notTags){
			commit('setInboxFiltersNotTags', notTags)
	},
		setInboxFiltersAfter({ commit }, after){
			commit('setInboxFiltersAfter', after)
	},
		setInboxFiltersBefore({ commit }, before){
			commit('setInboxFiltersBefore', before)
	},
		setInboxFiltersIsMention({ commit }, isMention){
			commit('setInboxFiltersIsMention', isMention)
	},
		setInboxFiltersAssignedToMe({ commit }, assignedTo){
			commit('setInboxFiltersAssignedToMe', assignedTo)
	},
		setInboxFilterLastUpdatedTime({ commit }, updatedTime){
			commit('setInboxFilterLastUpdatedTime', updatedTime)
	},
		setSaveFilters({ commit }, inboxFilters, email){
			commit('setSaveFilters', inboxFilters, email)
	}
}
}

export default inboxFilters;


// WEBPACK FOOTER //
// ./src/store/inboxFilters.js